import * as React from 'react'
import { Form } from 'react-bootstrap'

import AddCubeSheetItem, { itemSelect } from './AddCubeSheetItem'

import ResidentialItems from './ResidentialItems'
import { copyObject } from '../../../../../utils'
import { DocumentT, JobT } from '../../../../../types/Job'
import { getVariableValue, setValueVariables, VariableDocumentT } from '../DocumentVariables'
import _ from 'lodash'
import CubeSheetLineItem from './CubeSheetLineItem'
import { sortItemsCupeSheetByCategory } from '../../JobUtils'
import { CargoT } from '../../../../../types/CargoT'
import { parseFloatTotal } from '../../../../../utils/utilsT'
import { useImmer } from 'use-immer'

export interface CubeSheetT extends DocumentT { }
export const CubeSheetObj: CubeSheetT = {
  active: true,
  title: 'Cube Sheet',
  name: 'cubeSheet',
  variables: [
    {
      key: "lineItems",
      type: "array",
      value: [],
    }
  ]

}



export const extractVariablesCubeSheet = (newJob: JobT): Array<VariableDocumentT> => {
  return _.has(newJob.documents, 'cubeSheet.variables') ? newJob.documents.cubeSheet.variables : []
}
interface CubeSheetProps {
  job: JobT
  updateJob(key: string, value: any): void
  updateDocument(key: string, value: any): void
}

const CubeSheet: React.FunctionComponent<CubeSheetProps> = (props): JSX.Element => {
  const [lineItems, setLineItems] = useImmer<Array<CargoT>>([])
  const [currentDocument, setCurrentDocument] = React.useState(CubeSheetObj)

  React.useEffect(() => {

    const newLineItems = extractLineItems(props.job)
    if (_.isArray(newLineItems) && !_.isEqual(newLineItems, lineItems)) {
      setLineItems(newLineItems)
    }

  }, [props.job]);

  const extractLineItems = (newJob: JobT): Array<any> => {
    const variables = extractVariablesCubeSheet(newJob)
    let lineItems = getVariableValue('lineItems', variables)
    return lineItems ? lineItems : []
  }



  const applyChange = (_variables: Array<VariableDocumentT>) => {
    let documentClone = _.cloneDeep(currentDocument)
    documentClone.variables = _variables
    setCurrentDocument(documentClone)
    props.updateDocument('cubeSheet', documentClone)
  }


  const applyChangeLineItems = (lineItems: Array<CargoT>) => {
    const previousVariables = extractVariablesCubeSheet(props.job)
    let variables = setValueVariables('lineItems', lineItems, previousVariables)
    applyChange(variables)
  }

  const addLineItem = (cargoItem: CargoT): void => {
    let lineItemsClone = _.cloneDeep(lineItems)
    lineItemsClone.push(cargoItem)
    setLineItems(lineItemsClone)
    applyChangeLineItems(lineItemsClone)
  }


  const removeCargoItem = (id: string): void => {
    let lineItemsClone = _.cloneDeep(lineItems)
    let findIndex = lineItemsClone.findIndex((x) => x.id == id)
    if (findIndex != -1) {
      lineItemsClone.splice(findIndex, 1)
      setLineItems(lineItemsClone)
      applyChangeLineItems(lineItemsClone)
    }

  }

  const updateCargo = (id: string, cargoItem: CargoT): void => {
    let lineItemsClone = _.cloneDeep(lineItems)
    let findIndex = lineItemsClone.findIndex((x) => x.id == id)
    if (findIndex != -1) {
      lineItemsClone[findIndex] = cargoItem
      setLineItems(lineItemsClone)
      applyChangeLineItems(lineItemsClone)
    }
  }



  const renderItems = () => {
    if (!_.isArray(lineItems)) {
      return null
    }
    let categories = sortItemsCupeSheetByCategory(lineItems)
    return Object.keys(categories).map((category) => {
      return categories[category].map((item, index) => {
        return (
          <div key={index}>
            {index == 0 && <h5>{item.category}</h5>}
            <CubeSheetLineItem
              index={index}
              item={item}
              onChangeItem={(newItem) => {
                updateCargo(item.id, newItem)
              }}
              removeCargoItem={() => {
                removeCargoItem(item.id)
              }} />
          </div>
        )
      })
    })

  }


  const sumTotal = (items: Array<CargoT>): number => {
    if (!_.isArray(items)) return 0

    return items.reduce((value, lineItem, index) => {
      let total = Number(value) + (Number(lineItem?.volume) * Number(lineItem?.units))
      return total
    }, 0)
  }


  const renderLineTotal = () => {
    return (
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 30px' ,gap: 4 }}>


        <div></div>
        <div></div>
        <div></div>
       
        <div>
          <Form.Label><strong>Total, $</strong></Form.Label>
          <Form.Control
            className='input-material'
            disabled
            // @ts-ignore
            value={`${parseFloatTotal(sumTotal(lineItems))}`} />
        </div>
        <div>
          <Form.Label><strong>Total, Pounds</strong></Form.Label>
          <Form.Control
            className='input-material'
            disabled
            // @ts-ignore
            value={`${parseFloatTotal(sumTotal(lineItems) *7)}`} />
        </div>
        <div></div>
        <div></div>
      </div>
    )
  }


  return (
    <div className='w-100'>
      {renderItems()}
      {_.isArray(lineItems) && lineItems.length > 0 && renderLineTotal()}
      <AddCubeSheetItem
        addCargo={addLineItem} />

    </div>
  )
}

export default CubeSheet
